<div class="contnet">
    <h1 class="page-title">SNGP</h1>
    <p>
        <strong
            ><a href="https://tenis-integrado-prod.s3.us-east-1.amazonaws.com/sync-prod/id22798/banners/sngp-banner.png"
                ><img
                    alt=""
                    src="https://tenis-integrado-prod.s3.us-east-1.amazonaws.com/sync-prod/id22798/banners/sngp-banner.png"
                    style="width: auto; height: 72px" /></a
        ></strong>
    </p>

    <p>
        <strong
            >Com o objetivo de valorizar os profissionais capacitados e incentivar a todos os treinadores a buscar
            formação e atualização constante, foi criado o Sistema Nacional de Graduação Profissional (SNGP).</strong
        >
    </p>

    <p>
        Entendemos que alguns aspectos importantes fazem a diferença na formação de um profissional bem preparado e
        atualizado. Portanto, para que possamos ser o mais justos e coerentes possível, levaremos em consideração não só
        os cursos realizados pelos profissionais como também a sua história como jogador e técnico, experiência de
        trabalho e formação escolar/universitária.
    </p>

    <p>
        O SNGP tem 5 níveis diferenciados (em forma de pirâmide): Instrutor, Treinador, Treinador Nacional, Técnico
        Nacional e Técnico Master.
    </p>

    <p><strong>Veja abaixo a Pirâmide do SNGP&nbsp;</strong></p>

    <p>
        <img
            alt=""
            src="https://c2.staticflickr.com/6/5690/23199363634_cd6638b336_o.jpg"
            style="width: 516px; height: 222px"
        />
    </p>

    <p>
        Acreditamos que com a ampla divulgação deste sistema, os profissionais que atingirem graduações superiores serão
        naturalmente beneficiados pela seleção do mercado do tênis.
    </p>

    <p>Requisitos básicos e normas de funcionamento para ingressar no sistema:</p>

    <p>
        1. Aprovação nos cursos de Nível I da CBT realizados até dezembro de 2004, ou aprovação nos cursos de Nível I da
        ITF, ou aprovação nos cursos oficiais da CBT: Módulo A, Módulo B e Módulo C (a partir de 2005).
    </p>

    <p>2. Ser um profissional filiado ao Depto. de Capacitação da CBT e em dia com as suas contribuições.</p>

   

    <p>
        &nbsp;3. Apresentar o currículo ao Departamento de Capacitação, incluindo os certificados de todas as atividades
        e carga horária mencionadas dentro do mesmo. É importante salientar, que é de responsabilidade do profissional
        comprovar as informações que constam em seu currículo
    </p>

    <p>
        Obs: Enviar junto com os documentos a tabela de pontuação do SNGP com seu respectivo calculo. A tabela se
        encontra nas ultimas páginas deste explicativo ou no site www.cbtenis.com.br no link capacitação, em SNGP
    </p>

    <p>
        Esclarecemos que para a inserção no sistema, serão considerados cursos, congressos, simpósios e workshops
        realizados até dezembro de 2005, após essa data, somente cursos oficiais ou outorgados pela CBT.&nbsp;
    </p>

    <p>4. Serão levados em consideração os seguintes aspectos:</p>

    <p>
        a) Cursos oficiais da CBT;&nbsp;<br />
        b) Cursos, congressos, conferências e workshops;&nbsp;<br />
        c) Histórico como jogador;&nbsp;<br />
        d) Histórico como treinador;&nbsp;<br />
        e) Anos de docência;&nbsp;<br />
        f) Formação escolar e universitária.&nbsp;
    </p>

    <p>
        5. As informações apresentadas serão analisadas e avaliadas pela comissão técnica da área de capacitação da CBT
        de acordo com a tabela de pontos do SNGP que está em anexo
    </p>

    <p>
        6. Ao realizar o mesmo curso (com os mesmos conteúdos) por mais de uma vez, o profissional não receberá os
        pontos por cada vez que o realiza.
    </p>

    <p>
        7. A comissão técnica emitirá a graduação alcançada pelo profissional, mediante a pontuação oferecida pela
        tabela do SNGP.
    </p>

    <p>
        8. Se os dados estiverem incompletos, a comissão se comunicará com o profissional para solicitar mais
        informações a respeito.
    </p>

    <p>
        9. O profissional poderá apelar por escrito para ser informado detalhadamente sobre como foi estabelecida a sua
        graduação.
    </p>

    <p>10. Ao profissional graduado será entregue um título oficial de graduação da CBT.</p>

    <p>
        11. O título poderá ser retirado na sede da CBT ou então ser enviado pelo correio ao domicílio que constar no
        currículo.
    </p>

    <p>
        12. Uma vez estabelecida a graduação do profissional, o mesmo deverá seguir capacitando-se caso deseje ascender
        a um nível superior.
    </p>

    <p>
        13. O profissional que apresentar documentos e atestados que não condizem com a verdade, terá o seu título
        cancelado e seu nome excluído do SNGP por 2 anos.
    </p>

    <p><strong>Como melhorar a Graduação Profissional</strong></p>

    <p>
        Uma vez que o profissional esteja inserido no SNGP, este poderá conquistar pontos e ascender no sistema somente
        através dos cursos, congressos, simpósios e workshops oficiais ou outorgados pela CBT.
    </p>

    <p>Tempo de permanência em cada nível</p>

    <p>
        Quando o profissional ingressa na pirâmide a primeira ascensão (promoção) para o próximo patamar pode ser
        imediata não havendo um tempo estipulado, o mesmo poderá fazê-lo quando achar conveniente ou quando conquistar
        os pontos necessários.
    </p>

    <p>A partir da primeira promoção, haverá um tempo de permanência mínima em cada um dos seguintes níveis:</p>

    <p>
        · Treinador - 2 anos&nbsp;<br />
        · Treinador Nacional - 3 anos&nbsp;<br />
        · Técnico Nacional - 3 anos
    </p>

    <p>
        <strong>Esclarecimentos para os profissionais aprovados nos Cursos de Nível 1, 2, 3 e 4</strong>
    </p>

    <p>
        Todos os cursos de capacitação da CBT realizados até dezembro de 2004 serão considerados. Para cada um dos
        níveis o profissional receberá 30 pontos. Exemplo: o profissional que foi aprovado no Nível 1 estará garantido
        no SNGP e receberá 30 pontos; no Nível 2 receberá mais 30 pontos e assim sucessivamente.
    </p>

    <p>
        Para o profissional que não foi aprovado no Curso de Nível 1 da CBT (até dezembro/04) é necessário que seja
        aprovado nos módulos A/B/C para que ingresse no SNGP. Estes módulos juntos terão 75 horas de carga horária e
        darão 60 pontos.
    </p>

    <p>
        Se o profissional que já tiver sido aprovado nos Cursos de Nível 1,2,3 e 4 desejar se atualizar e acumular
        pontos para o SNGP, poderá fazer os Módulos A/B/C e receberá os pontos relativos a cada módulo de maneira
        independente (20 pontos por módulo).
    </p>

    <p>
        <a href="https://tenis-integrado-prod.s3.us-east-1.amazonaws.com/sync-prod/id22798/anexos/Planilha+de+Pontuac%CC%A7a%CC%83o+2025.xlsx" target="_blank"
            ><b>CLIQUE AQUI PARA ACESSAR A TABELA DE PONTUAÇÃO PARA INSERÇÃO NO SNGP</b></a
        >
    </p>
</div>
